// extracted by mini-css-extract-plugin
export var typingIndicator = "_st-0";